import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import voteIcon from "../../../../assets/customerAssets/freeVotesIcon.svg";
import VideoComoponent from "./VideoComoponent";
import OptionMenue from "../OptionMenue";

const GoalVideoComponent = ({ data, filterState, deleteGoalFunc }) => {
  const [voteState, setVoteState] = useState(
    data?.goalVotes?.length > 0 ? data?.goalVotes[0]?.count : 0,
  );

  const [viewGoal, setViewGoal] = useState(false);

  useEffect(() => {
    setVoteState(data?.goalVotes?.length > 0 ? data?.goalVotes[0]?.count : 0);
  }, [data]);

  return (
    <>
      <Box className="goal-video-outter" style={{ paddingLeft: "30px" }}>
        <Box className="goal-video-wrapper">
          <Box className="video-wrapper ">
            <VideoComoponent
              img={data?.thumbnail}
              duration={data?.duration}
              data={data}
              voteCount={voteState}
              setVoteCount={setVoteState}
              viewGoal={viewGoal}
              setViewGoal={setViewGoal}
            />
          </Box>
          <Box
            className="goal-info-wrapper"
            sx={{ cursor: "pointer" }}
            onClick={() => setViewGoal(true)}
          >
            <Typography component="h3">{data?.title}</Typography>
            <Box className="votes-wrapper">
              <img src={voteIcon} height={20} width={20} />
              <Typography component="p">
                {voteState + " "}
                votes
              </Typography>
            </Box>
          </Box>
          <Box className="more-options">
            <OptionMenue
              data={data}
              filterState={filterState}
              deleteFunc={deleteGoalFunc}
              isAdmin={true}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default GoalVideoComponent;
